import React, { useEffect, useState } from "react";
import { Layout, Row, Col, Pagination } from "antd";
import CommonReportTable from "utils/table/CommonReportTable";
import InventoryTabs from "../InventoryTabs";
import { soldInventoryHeaders } from "./soldInventoryUtils";
import { ICustomError } from "models/interfaces/ICustomError";
import { AppSetting } from "utils/appSettings";
import { LoggerService } from "sharedServices";
import CustomError from "controls/CustomError/CustomError";
import { ISoldInventoryData } from "models/interfaces";
import { formatThousandSeparator } from "utils/commonFunction";
import { HouseKeepingService } from "services/StubHubServices/houseKeepingServices/houseKeepingService.service";

const { Content } = Layout;
const DEFAULT_PAGE_INDEX = AppSetting.DEFAULT_PAGE_INDEX;
const PAGE_SIZE = AppSetting.PAGE_SIZE;

const SoldInventoryTable: React.FC<{
  path: string;
  searchQuery: string | null;
}> = ({ path, searchQuery }) => {
  const [queryParams, setQueryParams] = useState<any>(null);
  const [soldInventoryData, setSoldInventoryData] =
    useState<ISoldInventoryData | null>(null);
  const [showLoader, setShowLoader] = useState(false);
  const [dataFetchError, setDataFetchError] = useState<ICustomError | null>(
    null
  );

  const [defaultQueryParams] = useState<any>({
    clientZone: AppSetting.TIMEZONE,
    pageIndex: DEFAULT_PAGE_INDEX,
    pageSize: PAGE_SIZE,
    sortColumn: "plDate",
    sortOrder: "desc",
  });

  const getSoldInventoryData = async (query: any) => {
    try {
      setShowLoader(true);
      const response = await new HouseKeepingService().getSoldInventoryList({
        ...query,
      });

      setSoldInventoryData(response.data.data);
      setShowLoader(false);
    } catch (error: any) {
      setShowLoader(false);
      await new LoggerService().log({
        payload: error,
        function_name: "getActiveInventoryData",
      });

      setDataFetchError({ ...error, refreshAction: getSoldInventoryData });
    }
  };

  useEffect(() => {
    queryParams && getSoldInventoryData(queryParams);
  }, [queryParams]);

  useEffect(() => {
    if (defaultQueryParams) {
      setQueryParams({
        ...defaultQueryParams,
        ...queryParams,
        pageIndex: DEFAULT_PAGE_INDEX,
      });
    }
  }, [defaultQueryParams]);

  useEffect(() => {
    if (searchQuery !== null) {
      setQueryParams({
        ...queryParams,
        pageIndex: DEFAULT_PAGE_INDEX,
        searchText: searchQuery,
      });
    }
  }, [searchQuery]);

  const getViewTable = () => {
    if (!showLoader && 
      soldInventoryData && 
      soldInventoryData?.total) {
        return (
          <ul className="innerHeaderRight">
            <li>
              <h4>
                {soldInventoryData?.total === 1
                  ? formatThousandSeparator(soldInventoryData?.total) +
                    " Record Found"
                  : formatThousandSeparator(soldInventoryData?.total) +
                    " Records Found"}
              </h4>
            </li>
            <li>
              <Pagination
                className="pagination"
                hideOnSinglePage={true}
                defaultCurrent={1}
                current={queryParams?.pageIndex}
                total={soldInventoryData?.total}
                pageSize={PAGE_SIZE}
                onChange={(pageNumber) =>
                  setQueryParams({
                    ...queryParams,
                    pageIndex: pageNumber,
                  })
                }
                showSizeChanger={false}
              />
            </li>
          </ul>
        );
    }
    return (
      <div style={{ height: 21 }}></div>
    );
  }

  return dataFetchError ? (
    <CustomError {...dataFetchError} />
  ) : (
    <Content className="mainContainer relative">
      <div className="cancelledShowsPagination">
        <Row className="flx justifyContentBetween alignItemsCenter">
          <Col span={24}>
            { getViewTable() }
          </Col>
        </Row>
      </div>
      <div className="tabContainer removeTblLRSpc">
        <InventoryTabs path={path} />
        <div className="">
          <CommonReportTable
            // tableClass="customTbl scroll-x-y fixedHeaderFooter"
            tableHeight={{ maxHeight: "calc(100vh - 218px)" }}
            onSort={(sortIndex: string, sortOrder: "asc" | "desc") => {
              setQueryParams({
                ...queryParams,
                sortColumn: sortIndex,
                sortOrder: sortOrder,
              });
            }}
            sortField={{
              dataIndex: queryParams?.sortColumn,
              order: queryParams?.sortOrder,
            }}
            data={
              soldInventoryData?.soldInventoryData ?? []
            }
            headers={soldInventoryHeaders}
            loading={showLoader}
            enableRowSelect={false}
          />
        </div>
      </div>
    </Content>
  );
};

export default SoldInventoryTable;
